<cyborg-section id="popular">
  <cyborg-section-title>
    <div class="logo">
      <hyperkit-typography variant="h3" align="left" color="primary"
        >Recently Updated</hyperkit-typography
      >
    </div>
  </cyborg-section-title>
  @for (packages of recentHuntPackages$ | async; track packages) {
    <hunt-package [data]="packages"></hunt-package>
  }
</cyborg-section>
